import { ConsentType } from '@mfe/types/common';
import store from '@mfe/store';
import { toggle } from '@mfe/store/consents';

export const localDate = (date?: string): string | null => (date ? new Date(date).toLocaleDateString('de') : null);
export const localTime = (date?: string): string | null => (date ? new Date(date).toLocaleTimeString('de') : null);

export function filterPredicator(consent: ConsentType): boolean {
  return !consent.deprecated && consent.modeconstraint !== 'view';
}

export function doToggle({ id, fid, feature }: { id: string, fid?: string, feature?: string }) {
  return () => {
    store.dispatch(toggle({ id, fid, feature }));
  };
}
